import React from "react";

import { useApi } from "../../rootWrapper";
import Card from "common/components/Card/Card.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import TextField from "../../common/components/forms/TextField";
import { useForm } from "../../core-module/hook/connectingHooks";

// @material-ui/core components
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Button from "common/components/CustomButtons/Button.jsx";
import Dialog from "@material-ui/core/Dialog";
import Divider from "@material-ui/core/Divider";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

//@material-ui/icons
import EditIcon from "@material-ui/icons/Edit";
import Assignment from "@material-ui/icons/Assignment";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import LabelImportantIcon from "@material-ui/icons/LabelImportant";

//Styles
import withStyles from "@material-ui/core/styles/withStyles";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import { isNativeIosPlatform } from "../../deviceInfo";

const importedStyle = dashboardStyle;

const styles = (theme) => ({
  cardIconTitle: importedStyle.cardIconTitle,
  emailDetails: {
    minWidth: 0,
    wordBreak: "break-word",
  },
  actionButtons: {
    display: "flex",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(1),
    },
  },
  compactActionButtons: {
    marginTop: theme.spacing(1),
  },
});

function ServiceEmailAddressesComponent(props) {
  const api = useApi();
  const useNativeIosLayout = isNativeIosPlatform();

  const [openDialog, setOpenDialog] = React.useState(null);
  const { dialogType, selected } = openDialog || {};

  const formCreate = useForm(props.dataPath, {});
  const formEdit = useForm(props.dataPath, selected);

  const { data, classes } = props;

  const handleOpenDialog = (item) => {
    setOpenDialog(item);
  };

  const handleDialogClose = () => {
    setOpenDialog(null);
    formCreate.changeInput("forwardingaddress", "");
  };

  const handleConfirm = () => {
    switch (dialogType) {
      case "delete":
        handlePost({ abandon: true });
        break;
      case "enable-forwarding":
        handlePost({
          forwarding: true,
          forwardingaddress: formCreate.input["forwardingaddress"],
        });

        break;
      case "edit-forwarding":
        handlePost({ forwardingaddress: formEdit.input["forwardingaddress"] });
        break;
      default:
        console.log("Confirm");
        break;
    }
  };

  const handlePost = async (postBody) => {
    const postPath = `${props.dataPath}.${selected.id}`;
    await api.post(postPath, postBody);
    handleDialogClose();
  };

  const getDialogTitle = () => {
    switch (dialogType) {
      case "delete":
        return "Delete Email";
      case "enable-forwarding":
        return "Enable Email Forwarding";
      case "edit-forwarding":
        return "Edit Email Forwarding";
      default:
        return;
    }
  };

  const getDisabled = () => {
    if (
      dialogType === "enable-forwarding" &&
      (formCreate.invalid["forwardingaddress"] ||
        formCreate.input["forwardingaddress"] === "")
    )
      return true;
    return false;
  };

  const getDialogContent = () => {
    switch (dialogType) {
      case "delete":
        return (
          <DialogContentText>
            You are deleting the email{" "}
            <Box
              component="span"
              style={{ fontWeight: "bold", fontStyle: "italic" }}
            >
              {selected.email}
            </Box>
            , this action is irreversible. Would you like to continue?
          </DialogContentText>
        );
      case "enable-forwarding":
        return (
          <Box component="span">
            <DialogContentText>
              You are enablling forwarding for the email{" "}
              <Box
                component="span"
                style={{ fontWeight: "bold", fontStyle: "italic" }}
              >
                {selected.email}
              </Box>
              , this action is irreversible. To continue, please enter the email
              address you would like to forward to.
            </DialogContentText>
            <TextField
              autoFocus
              style={{ width: "100%" }}
              label="Forwarding"
              form={formCreate}
              propName="forwardingaddress"
            />
          </Box>
        );
      case "edit-forwarding":
        return (
          <TextField
            autoFocus
            style={{ width: "100%", minWidth: "300px" }}
            label="Forwarding"
            form={formEdit}
            propName="forwardingaddress"
            // onChange={handleEditChange}
          />
        );
      default:
        return;
    }
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Dialog onClose={handleDialogClose} open={Boolean(openDialog)}>
          <DialogTitle>{getDialogTitle()}</DialogTitle>
          <DialogContent>{getDialogContent()}</DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} color="primary">
              Cancel
            </Button>
            <Button
              onClick={handleConfirm}
              color="primary"
              disabled={getDisabled()}
            >
              {dialogType === "delete" ? "Yes" : "Continue"}
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
      <Grid item xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Service Email Addresses</h4>
          </CardHeader>
          <CardBody>
            <Grid container>
              {data.map((item, key) => (
                <Grid item xs={12} key={key} style={{ marginBottom: 10 }}>
                  <Grid container alignItems="center">
                    <Grid
                      item
                      xs={useNativeIosLayout ? 12 : 10}
                      sm={useNativeIosLayout ? (props.compact ? 12 : 7) : 10}
                      className={
                        useNativeIosLayout ? classes.emailDetails : undefined
                      }
                    >
                      <Typography>{item.email}</Typography>
                      {item.forwarding && (
                        <Typography
                          variant="body2"
                          style={{
                            fontStyle: "italic",
                            fontWeight: "light",
                            color: "gray",
                          }}
                        >
                          Forwarding: {item.forwardingaddress}
                        </Typography>
                      )}
                    </Grid>
                    <Grid
                      item
                      xs={useNativeIosLayout ? 12 : 2}
                      sm={useNativeIosLayout ? (props.compact ? 12 : 5) : 2}
                      className={
                        useNativeIosLayout
                          ? `${classes.actionButtons} ${
                              props.compact ? classes.compactActionButtons : ""
                            }`
                          : undefined
                      }
                    >
                      {item.forwarding && (
                        <Tooltip title="Edit Forwarding">
                          <Box>
                            <Button
                              color="primary"
                              variant="contained"
                              onClick={() =>
                                handleOpenDialog({
                                  dialogType: "edit-forwarding",
                                  selected: item,
                                })
                              }
                            >
                              Edit
                              {/* <EditIcon color="primary" /> */}
                            </Button>
                          </Box>
                        </Tooltip>
                      )}
                      {!item.forwarding && (
                        <Tooltip title="Enable Forwarding">
                          <Box>
                            <Button
                              color="primary"
                              variant="contained"
                              onClick={() =>
                                handleOpenDialog({
                                  dialogType: "enable-forwarding",
                                  selected: item,
                                })
                              }
                            >
                              Forward
                              {/* <LabelImportantIcon color="primary" /> */}
                            </Button>
                          </Box>
                        </Tooltip>
                      )}
                      <Tooltip title="Delete email">
                        <Box>
                          <Button
                            onClick={() =>
                              handleOpenDialog({
                                dialogType: "delete",
                                selected: item,
                              })
                            }
                            disabled={props.loggedAs === item.email}
                            variant="contained"
                            color={
                              props.loggedAs === item.email
                                ? "default"
                                : "primaryRed"
                            }
                          >
                            Delete
                            {/* <ExitToAppIcon
                            color={
                              props.loggedAs === item.email
                                ? "default"
                                : "error"
                            }
                          /> */}
                          </Button>
                        </Box>
                      </Tooltip>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </CardBody>
        </Card>
      </Grid>
    </Grid>
  );
}

export default withStyles(styles)(ServiceEmailAddressesComponent);
